<template>
  <ListOrders />
</template>

<script>
import LayoutDefault from "../../layouts/LayoutDefault";
import ListOrders from "../../components/orders/ListOrders";

export default {
  name: "Orders",
  components: {ListOrders},
  created() {
    this.$emit("update:layout", LayoutDefault);
  }
};
</script>


<style lang="scss">
</style>
